import type { TableColumn, ColumnOption } from "../v2/Tables/Table/TableTypes";
export const EditColumnsStoreSymbol = Symbol.for("EditColumnsStore");

export interface IEditColumnsStore<T = any> {
  isOpen: boolean;
  selectedColumns: string[];
  initialize(storageKey: string, tableColumns: Array<TableColumn<T>>): void;
  getSearch(): string;
  setSearch(value: string): void;
  getFilteredColumns(): ColumnOption[];
  allFilteredSelected(): boolean;
  getTempSelectedColumns(): string[];
  toggleColumn(key: string): void;
  handleSelectAll(): void;
  open(): void;
  close(): void;
  confirm(): string[];
  handleDragEnd(sourceIndex: number, destinationIndex: number): void;
  updateColumnName(columnKey: string, newName: string): void;
  resetToDefault(): void;
  getSortedColumns(): TableColumn<T>[];
}
